module.exports = __webpack_public_path__ + "media/images/dline-3e479a3168aab34d135b6443c79f131e.svg";